import { refreshReducersToInitial } from "./refreshData-action";

export const REQUESTED_MAKE_MODEL = "REQUESTED_MAKE_MODEL" as const;
export const REQUESTED_MAKE_MODEL_SUCCESS =
  "REQUESTED_MAKE_MODEL_SUCCESS" as const;
export const REQUESTED_MAKE_MODEL_FAILED =
  "REQUESTED_MAKE_MODEL_FAILED" as const;
export const RESET_MAKE_MODEL = "RESET_MAKE_MODEL" as const;

type RequestMakeModelPayload = {
  year: string;
};

export function requestMakeModel(payload: RequestMakeModelPayload) {
  return { type: REQUESTED_MAKE_MODEL, payload };
}

export function requestMakeModelSuccess(payload) {
  return { type: REQUESTED_MAKE_MODEL_SUCCESS, payload };
}

export function requestMakeModelFailed(payload) {
  return { type: REQUESTED_MAKE_MODEL_FAILED, payload };
}

export function resetMakeModel() {
  return { type: RESET_MAKE_MODEL };
}

export type GetMakeModelActions =
  | ReturnType<typeof refreshReducersToInitial>
  | ReturnType<typeof requestMakeModel>
  | ReturnType<typeof requestMakeModelSuccess>
  | ReturnType<typeof requestMakeModelFailed>
  | ReturnType<typeof resetMakeModel>;
